import React, { useState } from "react";

import { i18n } from "../../../translate/i18n";

export default function CommentReplyComposer({ disabled, onSubmit }) {
	const [text, setText] = useState("");

	const handleSubmit = (e) => {
		e.preventDefault();
		const trimmed = text.trim();
		if (!trimmed) return;
		onSubmit(trimmed);
		setText("");
	};

	return (
		<form onSubmit={handleSubmit} className="border-t border-default-200 pt-4 dark:border-default-700">
			<textarea
				className="form-input mb-3 min-h-[88px] w-full resize-y text-sm"
				placeholder={i18n.t("socialComments.reply.placeholder")}
				value={text}
				onChange={(e) => setText(e.target.value)}
				disabled={disabled}
			/>
			<div className="flex justify-end">
				<button
					type="submit"
					className="btn bg-primary text-white"
					disabled={disabled || !text.trim()}
				>
					{i18n.t("socialComments.actions.reply")}
				</button>
			</div>
		</form>
	);
}
